import { inBrowser } from '@/utils/capabilities';

import type { OAuthReturnTo } from '@littlebird/mcp';

// mirrors the backend's return_path validation; an unsendable path degrades to
// the default CTA instead of failing the connect with a 422
const SENDABLE_PATH = /^\/(?!\/)[A-Za-z0-9\-._~/?#&=%+:@]{0,199}$/;

export const currentPageReturnTo = (): OAuthReturnTo | undefined => {
  if (!inBrowser()) return undefined;
  const path = window.location.pathname + window.location.hash;
  return SENDABLE_PATH.test(path) ? { path } : undefined;
};
